import React from "react";
import { Close, HelpDrawer } from "@cmsgov/ds-medicare-gov";
import { FormattedHTMLMessage } from "react-intl-phraseapp";
import { Link } from "react-router-dom";
import routes from "../../app/routes";
import { sendTealiumEvent, useTranslate } from "../../helpers";
import URI from "urijs";

export interface LandingPageMedigapHelpDrawerProps {
  setShowMedigapHelp: React.Dispatch<React.SetStateAction<boolean>>;
}

export const LandingPageMedigapHelpDrawer: React.FC<LandingPageMedigapHelpDrawerProps> = ({
  setShowMedigapHelp,
}) => {
  const t = useTranslate();
  const language = window.navigator.language.toLowerCase();
  const medigapLink = new URI(
    `${routes.medigap.landingPage}${location.search}`
  ).addQuery({ lang: language });
  const continueLink = medigapLink.toString();

  return (
    <div className="mct-c-help-drawer">
      <HelpDrawer
        heading={t("ooe_landing.looking_for")}
        onCloseClick={(): void => setShowMedigapHelp(false)}
        closeButtonText={<Close />}
        ariaLabel={t("close_help_drawer")}
      >
        <div className="ds-u-text-align--left">
          <p>{t("ooe_landing.medigap_explain_1")}</p>

          <p>
            <FormattedHTMLMessage id="ooe_landing.medigap_explain_2" />
          </p>

          <p>
            <FormattedHTMLMessage id="ooe_landing.medigap_explain_3" />
          </p>

          <div className="ds-u-text-align--center ds-u-margin-top--5">
            <Link
              to={continueLink}
              className="ds-c-button ds-c-button--big ds-c-button--primary"
              onClick={(): void => {
                sendTealiumEvent("Help Drawer", "Continue", "Medigap");
              }}
            >
              {t("ooe_landing.continue")}
            </Link>
          </div>
        </div>
      </HelpDrawer>
    </div>
  );
};
